import request from '@utils/request';
import url from '@utils/url';

const { HOST } = url;

export async function partnerList(params) {
    const url = `${HOST}/cps-gateway/api/v1/partner/list`;

    return request({ method: 'get', url: url }, params);
}

export async function update(data) {
    const url = ` ${HOST}/cps-gateway/api/v1/partner/status`;
    
    return request({ method: 'post', url: url }, data);
}

export async function deletePartner(data) {
    const url = ` ${HOST}/cps-gateway/api/v1/partner/del`;
    
    return request({ method: 'post', url: url }, data);
}

export async function contractList() {
    const url = `${HOST}/cps-gateway/api/v1/partner/contract/list`;

    return request({ method: 'get', url: url });
}

export async function updatePartner(data) {
    const url = ` ${HOST}/cps-gateway/api/v1/partner/update`;
    
    return request({ method: 'post', url: url }, data);
}